class DailyRitualConnector extends HTMLElement {
  constructor() {
    super();
    this.line = this.querySelector('.daily-ritual-steps__connector-line');
    this.icons = Array.from(this.querySelectorAll('.daily-ritual-steps__marker-icon'));
    this.resizeTimeout = null;
    this.handleResize = this.handleResize.bind(this);
  }

  connectedCallback() {
    if (!this.line || this.icons.length < 2) return;
    this.updateLine();
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    clearTimeout(this.resizeTimeout);
  }

  handleResize() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => this.updateLine(), 150);
  }

  updateLine() {
    const containerRect = this.getBoundingClientRect();
    const rows = Array.from(this.querySelectorAll('.daily-ritual-steps__row'));
    const lastRow = rows[rows.length - 1];

    const firstRect = this.icons[0].getBoundingClientRect();
    const lastRowRect = lastRow.getBoundingClientRect();

    const firstCenterY = firstRect.top + firstRect.height / 2 - containerRect.top;
    const centerX = firstRect.left + firstRect.width / 2 - containerRect.left;
    // Runs to the bottom of the last row's fixed-height slot (see
    // .daily-ritual-steps__row's height in the CSS), not just to the last
    // icon's center - matches Figma, where the line continues through the
    // remaining space of the last 145px block instead of stopping at the text.
    const endY = lastRowRect.bottom - containerRect.top;

    this.line.style.top = `${firstCenterY}px`;
    this.line.style.height = `${Math.max(endY - firstCenterY, 0)}px`;
    this.line.style.left = `${centerX}px`;
  }
}

customElements.define('daily-ritual-connector', DailyRitualConnector);
